import { logOut } from '../common/auth/Auth';
import { getBaseUrl } from '../common/getBaseUrl';

const { REACT_APP_TIMELIVE_API_URL, NODE_ENV, REACT_APP_TIMELIVE_ACCESS_TOKEN } = process.env;

declare const chrome: any;
export const fetchAPI = async (
    url: string, 
    method: string, 
    body?: any, 
    includeHeader: boolean = true, 
    accessToken: string = '', 
    isAttachment: boolean = false
) => {
    let finalBody = null;
    if (body !== "" && body !== undefined && body !== null) {
        finalBody = isAttachment ? body : JSON.stringify(body);
    }

    const isExtension = typeof chrome !== 'undefined' && chrome.runtime && chrome.runtime.id;
    
    let base_url = '';

    if (NODE_ENV === 'development' && !isExtension) {
        base_url = REACT_APP_TIMELIVE_API_URL as string;
        accessToken = REACT_APP_TIMELIVE_ACCESS_TOKEN as string;
    } else if (isExtension) {
        const dynamicBaseUrl = await getBaseUrl(); 
        const cleanDomain = dynamicBaseUrl ? dynamicBaseUrl.trim().replace(/\/+$/, '') : '';
        if (cleanDomain.includes('localhost') || cleanDomain.includes('127.0.0.1') || cleanDomain.includes('192.168.')) {
            base_url = `${cleanDomain}/`;
        } else if (cleanDomain) {
         base_url = cleanDomain.endsWith('/classic') ? `${cleanDomain}/` : `${cleanDomain}/classic/`;
        } else {
            base_url = (REACT_APP_TIMELIVE_API_URL as string);
        }

    } else {
        base_url = window.origin + '/classic/';
    }

    if (!base_url.endsWith('/')) {
        base_url += '/';
    }
    const cleanUrl = url.startsWith('/') ? url.slice(1) : url;

    let token = localStorage.getItem('accessToken');
    if (!token && isExtension && typeof chrome !== 'undefined' && chrome.storage) {
        const stored = await chrome.storage.local.get(['accessToken']);
        token = stored.accessToken || '';
    }

    let headersText: Record<string, string> = {};
    if (includeHeader) {
        if (isAttachment) {
            headersText = {
                "Accept-Language": navigator.language?.toLowerCase().startsWith("th") ? "en-UK" : navigator.language,
                'AccessToken': token || ''
            };
        } else {
            headersText = {
                "Accept-Language": navigator.language?.toLowerCase().startsWith("th") ? "en-UK" : navigator.language,
                'Content-Type': 'application/json',
                'AccessToken': token || ''
            };
        }
    }

    let init: RequestInit = {
        method: method,
        headers: headersText,
        body: finalBody,
        mode: 'cors',
    };

    if (url.includes("react.svc")) {
        init = {
            method: method,
            mode: 'cors',
            headers: headersText,
            body: finalBody
        };
    }

    if (NODE_ENV === 'production' && !isExtension) {
        init = {
            method: method,
            headers: headersText,
            body: finalBody
        };
    }

    try {
        const response = await fetch(base_url + cleanUrl, init);

        if (!response.ok) {
            if (response.status === 401) { 
                localStorage.clear();
                sessionStorage.clear();
                if (isExtension && typeof chrome !== 'undefined' && chrome.storage) {
                    chrome.storage.local.clear();
                }
                if (!isExtension) {
                    window.location.href = `${window.origin}`;
                }
                throw new Error('Unauthorized - ' + response.status);
            }
        }
        return response;
    }
    catch (error) {
        throw error;
    }
};

export default fetchAPI;
export const toBase64 = (str: string) => {
    return window.btoa(unescape(encodeURIComponent(str)));
};

// import { logOut } from '../common/auth/Auth';
// import { getBaseUrl } from '../common/getBaseUrl';
// const { REACT_APP_TIMELIVE_API_URL, NODE_ENV, REACT_APP_TIMELIVE_ACCESS_TOKEN } = process.env;


// declare const chrome: any;
// export const fetchAPI = async (
//     url: string, 
//     method: string, 
//     body?: any, 
//     includeHeader: boolean = true, 
//     accessToken: string = '', 
//     isAttachment: boolean = false
// ) => {
//     let finalBody = null;
//     if (body !== "" && body !== undefined && body !== null) {
//         finalBody = isAttachment ? body : JSON.stringify(body);
//     }

//     const isExtension = typeof chrome !== 'undefined' && chrome.runtime && chrome.runtime.id;
    
//     let base_url = '';

//     if (NODE_ENV === 'development') {
//         base_url = REACT_APP_TIMELIVE_API_URL as string;
//         accessToken = REACT_APP_TIMELIVE_ACCESS_TOKEN as string;
//           console.log('development - base_url',base_url)
//     } 
//     else if (isExtension) {
//         // Top import se getBaseUrl() ko call kar k dynamic URL retrieve ho jayega
//         const dynamicBaseUrl = await getBaseUrl(); 
//         base_url = dynamicBaseUrl ? `${dynamicBaseUrl}classic/` : (REACT_APP_TIMELIVE_API_URL as string);
//         console.log('isExtension - base_url', base_url);
//     }
//     // else if (isExtension) {
       
//     //     base_url = (REACT_APP_TIMELIVE_API_URL as string) || 'https://your-timelive-domain.com/classic/'; 
//     //       console.log('isExtension - base_url',base_url)
//     // } 
//     else {
//         base_url = window.origin + '/classic/';
//         console.log('window.origin - base_url',base_url)
//     }

//     if (!base_url.endsWith('/')) {
//         base_url += '/';
//     }
//     const cleanUrl = url.startsWith('/') ? url.slice(1) : url;

//     let token = localStorage.getItem('accessToken');
//     if (!token && isExtension && typeof chrome !== 'undefined' && chrome.storage) {
//         const stored = await chrome.storage.local.get(['accessToken']);
//         token = stored.accessToken || '';
//     }

//     let headersText: Record<string, string> = {};
//     if (includeHeader) {
//         if (isAttachment) {
//             headersText = {
//                 'AccessToken': token || ''
//             };
//         } else {
//             headersText = {
//                 'Content-Type': 'application/json',
//                 'AccessToken': token || ''
//             };
//         }
//     }

//     let init: RequestInit = {
//         method: method,
//         headers: headersText,
//         body: finalBody,
//         mode: 'cors',
//     };

//     if (url.includes("react.svc")) {
//         init = {
//             method: method,
//             mode: 'cors',
//             headers: headersText,
//             body: finalBody
//         };
//     }

//     if (NODE_ENV === 'production' && !isExtension) {
//         init = {
//             method: method,
//             headers: headersText,
//             body: finalBody
//         };
//     }

//     try {
//         const response = await fetch(base_url + cleanUrl, init);

//         if (!response.ok) {
//             if (response.status === 401) { 
//                 localStorage.clear();
//                 sessionStorage.clear();
//                 if (isExtension && typeof chrome !== 'undefined' && chrome.storage) {
//                     chrome.storage.local.clear();
//                 }
//                 if (!isExtension) {
//                     window.location.href = `${window.origin}`;
//                 }
//                 throw new Error('Unauthorized - ' + response.status);
//             }
//         }
//         return response;
//     }
//     catch (error) {
//         throw error;
//     }
// };

// export default fetchAPI;
// const toBase64 = (str: string) => {
//     return window.btoa(unescape(encodeURIComponent(str)));
// };